/**
 * @file Barre du haut : soldes (argent, gemmes, rubis si debloque), DPS d'equipe, bouton reglages ; safe-area iOS.
 */
import type { WalletId } from '@shared/enums';
import { formatBig } from '@shared/format';
import { Component } from '../core/Component';
import { h, setText, toggleClass } from '../core/dom';
import { uiIcon } from '../core/uiIcons';
import { openScreen } from '../core/feedback';
import { currencyIcon } from '../core/icons';
import { balanceOf } from '../core/widgets';
import type { UiContext } from '../UiContext';

type ChipId = Extract<WalletId, 'money' | 'dia' | 'ruby'>;
const CHIPS: readonly ChipId[] = ['money', 'dia', 'ruby'];
const BUMP_SECONDS = 0.2;

interface ChipView {
  root: HTMLElement;
  value: HTMLElement;
  bump: number;
}

export class TopBar extends Component {
  private readonly chips = new Map<ChipId, ChipView>();
  private dps!: HTMLElement;

  constructor(ctx: UiContext) {
    super(ctx, 'div', 'topbar');
  }

  protected build(): void {
    const { i18n } = this.ctx;
    const row = h('div', { class: 'chips chips-stack' });
    for (const id of CHIPS) {
      const value = h('b', { class: 'chip-value' }, '0');
      const root = h('div', { class: `chip cur-${id}`, title: i18n.tDyn(`currency.${id}`) }, currencyIcon(id), value);
      this.chips.set(id, { root, value, bump: 0 });
      row.append(root);
    }
    this.dps = h('div', { class: 'dps' });
    const gear = h('button', { class: 'btn round gear', type: 'button', 'aria-label': i18n.t('menu.settings'), 'data-ui-block': true, 'data-fast': true, onclick: () => openScreen('settings') }, uiIcon('gear'));
    this.el.append(h('div', { class: 'topbar-main' }, row, this.dps), gear);

    this.listen('WalletChanged', (e) => {
      const chip = this.chips.get(e.id as ChipId);
      if (chip && e.delta.gt(0)) chip.bump = BUMP_SECONDS;
    });
    this.refresh();
  }

  private refresh(): void {
    const { query } = this.ctx.sim;
    for (const [id, chip] of this.chips) setText(chip.value, formatBig(balanceOf(this.ctx, id)));
    toggleClass(this.chips.get('ruby')?.root ?? this.el, 'is-hidden', !query.feature('rebirth'));
    setText(this.dps, `${this.ctx.i18n.t('stat.dps')} ${formatBig(query.teamDps())}`);
  }

  override update(dt: number): void {
    this.refresh();
    for (const chip of this.chips.values()) {
      if (chip.bump > 0) chip.bump = Math.max(0, chip.bump - dt);
      toggleClass(chip.root, 'bump', chip.bump > 0);
    }
  }
}
